<template>
  <div :class="classes">
    <svg
      v-if="content.kind === 'wrong'"
      class="c-result__icon"
      viewBox="0 0 34 34"
    >
      <path
        fill="#fff"
        d="M17 0C7.63 0 0 7.63 0 17c0 9.37 7.63 17 17 17 9.37 0 17-7.63 17-17 0-9.37-7.63-17-17-17zm6.88 21.87a.7.7 0 010 1l-1 1a.7.7 0 01-1 0L17 19l-4.87 4.88a.7.7 0 01-1 0l-1-1a.7.7 0 010-1L15 17l-4.88-4.87a.7.7 0 010-1l1-1a.7.7 0 011 0L17 15l4.87-4.88a.7.7 0 011 0l1 1a.7.7 0 010 1L19 17l4.88 4.87z"
      />
    </svg>
    <svg
      v-if="content.kind === 'correct'"
      class="c-result__icon"
      viewBox="0 0 34 34"
    >
      <path
        fill="#fff"
        d="M17 0C7.63 0 0 7.63 0 17c0 9.37 7.63 17 17 17 9.37 0 17-7.63 17-17 0-9.37-7.63-17-17-17zm9.5 12.53L15.64 23.3c-.64.63-1.67.68-2.35.04L7.54 18.1a1.73 1.73 0 01-.13-2.39c.64-.68 1.7-.72 2.39-.08l4.56 4.17 9.71-9.71a1.7 1.7 0 012.43 0 1.7 1.7 0 010 2.43z"
      />
    </svg>
    <div class="c-result__text" v-html="content.text" />
  </div>
</template>

<script>
import contentComponent from "@/mixins/content";

export default {
  name: "c-result",
  mixins: [contentComponent],

  computed: {
    extraMods() {
      return [this.content.kind];
    },
  },
};
</script>

<style lang="scss" scoped>
.c-result {
  background: #fff;
  font-weight: 300;
  padding: 1.25rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  max-width: 90%;
  font-size: 1.125rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: 2px solid #fff;

  @include media-breakpoint-down(xl) {
    font-size: 1rem;
    padding: 1.5rem;
  }
  @include media-breakpoint-down(lg) {
    font-size: 0.75rem;
    padding: 1rem;
  }
  @include media-breakpoint-down(md) {
    font-size: 0.625rem;
    padding: 0.75rem;
  }

  &--wrong {
    color: #fff;
    background: #7a7a7a;
  }
  &--correct {
    background: #ffd100;
    color: #001489;
  }

  ::v-deep {
    p {
      margin: 0;

      + p {
        margin: 1em 0 0;
      }
    }
    b {
      font-weight: bold;
    }
  }
  &__icon {
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    margin: 0 1.25rem 0 0;

    @include media-breakpoint-down(xl) {
      width: 1.5rem;
      height: 1.5rem;
      margin: 0 1rem 0 0;
    }
    @include media-breakpoint-down(lg) {
      width: 1rem;
      height: 1rem;
      margin: 0 0.5rem 0 0;
    }
  }
}
</style>
